export const isNotNullable = <T>(arg: T): arg is NonNullable<T> =>
  arg !== null && arg !== undefined;
